const mkui = require('./components');

const req = require.context('./components', true, /^\.\/locale\/.+_.+\.js/);

antd.locales = {};

req.keys().forEach(mod => {
  const matches = mod.match(/\/([^/]+).js/);
  antd.locales[matches[1]] = req(mod).default;
});

module.exports = mkui;
